<template>
  <form-wrapper :key="showTinCode">
    <form-group>
      <radio-input
        :value="stepFormData.is_usa_citizen"
        @input="emitInput('is_usa_citizen', $event)"
      >
        {{ $t('application-form.step-5.is_usa_citizen') }}
      </radio-input>
      <radio-input
        :value="stepFormData.has_residence"
        @input="emitInput('has_residence', $event)"
      >
        {{ $t('application-form.step-5.has_residence') }}
      </radio-input>
      <radio-input
        :value="stepFormData.is_usa_born"
        @input="emitInput('is_usa_born', $event)"
      >
        {{ $t('application-form.step-5.is_usa_born') }}
      </radio-input>
      <radio-input
        :value="stepFormData.has_usa_address"
        @input="emitInput('has_usa_address', $event)"
      >
        {{ $t('application-form.step-5.has_usa_address') }}
      </radio-input>
      <radio-input
        :value="stepFormData.has_usa_phone"
        @input="emitInput('has_usa_phone', $event)"
      >
        {{ $t('application-form.step-5.has_usa_phone') }}
      </radio-input>
      <radio-input
        :value="stepFormData.has_usa_payment_order"
        @input="emitInput('has_usa_payment_order', $event)"
      >
        {{ $t('application-form.step-5.has_usa_payment_order') }}
      </radio-input>
      <radio-input
        :value="stepFormData.has_usa_p_a"
        @input="emitInput('has_usa_p_a', $event)"
      >
        {{ $t('application-form.step-5.has_usa_p_a') }}
      </radio-input>

      <validation-provider v-if="showTinCode" v-slot="{errors}" rules="required|numeric">
        <text-input
          required
          :errors="[...errors, ...getFieldErrors('tin_code')]"
          :value="stepFormData.tin_code"
          :label="$t('application-form.step-5.tin_code')"
          :hint="$t('application-form.step-5.tin_code-hint')"
          @input="emitInput('tin_code', $event)"
        />
      </validation-provider>
    </form-group>
  </form-wrapper>
</template>

<script>
import FormWrapper from '@/components/views/RegisterPage/FormWrapper.vue'
import FormGroup from '@/components/views/RegisterPage/FormGroup.vue'
import RadioInput from '@/components/inputs/RadioInput.vue'
import {ValidationProvider} from 'vee-validate'
import TextInput from '@/components/inputs/TextInput.vue'

export default {
  name: 'StepFatca',
  components: { TextInput, RadioInput, FormGroup, FormWrapper, ValidationProvider },
  props: {
    stepFormData: {
      type: Object,
      required: true
    },
    isOlderThan45: {
      type: Boolean,
      default: false
    },
    backendErrors: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    showTinCode() {
      return [
        this.stepFormData.is_usa_citizen,
        this.stepFormData.has_residence,
        this.stepFormData.is_usa_born,
        this.stepFormData.has_usa_address,
        this.stepFormData.has_usa_phone
      ].some(item => item)
    }
  },
  watch: {
    showTinCode(newVal) {
      if (!newVal) {
        this.emitInput('tin_code', '')
      }
    },
  },
  methods: {
    emitInput(formKey, value) {
      this.$emit('update-field', {formKey, value})
    },
    getFieldErrors(fieldName) {
      return this.backendErrors[fieldName] ?? []
    }
  }
}
</script>

<style scoped>

</style>
